import { render, staticRenderFns } from "./fbaOrder.vue?vue&type=template&id=10c8017f&scoped=true"
import script from "./fbaOrder.vue?vue&type=script&lang=js"
export * from "./fbaOrder.vue?vue&type=script&lang=js"
import style0 from "./fbaOrder.vue?vue&type=style&index=0&id=10c8017f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c8017f",
  null
  
)

export default component.exports